export class Settings {
	public constructor(settings: any) {
		Object.assign(this, settings);
	}
}
export interface Settings {
	base: string;
	url(url: string): string;
	name: string;
	author: string;
	description: string;
	minDate: string;
	mainMenu: Array<{ icon: [string, string]; title: string; to: string; exact: boolean }>;
	errorPages: {
		default: { icon: [string, string]; title: string; message: string; statusCode: number };
		[code: string]: { icon: [string, string]; title: string; message: string; statusCode: number };
	};
	cardTypeQuestionId: string;
	cardTypeAnswerId: string;
	programId: string;
	sourceId: string;
	lockEnabled: string;
	lockPassword: string;

	benefitSelectionSurveyId: string;
	selectBenefitsQuestionId: string;
	priorAuthAnswerId: string;
	appealsClaimAnswerId: string;
	copayProgramIdAnswerId: string;
	papAnswerId: string;
	nursingSupportAnswerId: string;

	legalRepEmailQuestionId: string;
	legalRepEmailAnswerId: string;

	clinicalInformationSurveyId: string;
	diagnosisQuestionId: string;
	diagnosisAnswersId: string;
	icd10QuestionId: string;
	icd10AnswerId: string;
	diagnosisDateQuestionId: string;
	diagnosisDateAnswerId: string;
	patientWeightQuestionId: string;
	patientWeightAnswerId: string;
	mostRecentTherapiesQuestionId: string;
	mostRecentTherapiesAnswerId: string;
	priorTherapiesQuestionId: string;
	priorTherapiesAnswerId: string;
	papDiagnosisQuestionId: string;
	papDiagnosisAnswerId: string;
	papIcd10QuestionId: string;
	papIcd10AnswerId: string;
	papDiagnosisDateQuestionId: string;
	papDiagnosisDateAnswerId: string;
	papPatientWeightQuestionId: string;
	papPatientWeightAnswerId: string;
	papMostRecentTherapiesQuestionId: string;
	papMostRecentTherapiesAnswerId: string;
	papPriorTherapiesQuestionId: string;
	papPriorTherapiesAnswerId: string;
	prescriptionHcpNameQuestionId: string;
	prescriptionHcpNameAnswerId: string;
	prescriptionHcpSignatureQuestionId: string;
	prescriptionHcpSignatureAnswerId: string;
	prescriptionHcpSignatureDateQuestionId: string;
	prescriptionHcpSignatureDateAnswerId: string;

	prescriberAttestationSurveyId: string;
	prescriberNameQuestionId: string;
	prescriberNameAnswerId: string;
	prescriberSignatureQuestionId: string;
	prescriberSignatureAnswerId: string;
	attestationDateQuestionId: string;
	attestationDateAnswerId: string;

	corporateName: string;
	drug: string;
	phone: string;
}
